'use client';
import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

export const TTOSTestimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Rohit Sharma',
      role: 'Restaurant Owner, Pune',
      avatar: 'RS',
      avatarBg: 'from-amber-500 to-orange-600',
      quote:
        "TT OS built my website, manages my social media and brings me more customers every week. It's like having a whole team!",
      rating: 5,
    },
    {
      name: 'Dr. Priya Nair',
      role: 'Dental Clinic, Kochi',
      avatar: 'PN',
      avatarBg: 'from-emerald-500 to-teal-600',
      quote:
        'The AI manager understands my clinic needs. My appointments increased by 40% after using TT OS.',
      rating: 5,
    },
    {
      name: 'Ankit Verma',
      role: 'Digital Marketer & Agency Lead, Delhi',
      avatar: 'AV',
      avatarBg: 'from-indigo-500 to-purple-600',
      quote:
        'As a freelancer, TT OS helps me manage multiple clients from one dashboard. Game changer!',
      rating: 5,
    },
    {
      name: 'Meera Deshmukh',
      role: 'Boutique Apparel, Mumbai',
      avatar: 'MD',
      avatarBg: 'from-pink-500 to-rose-600',
      quote:
        'The automated WhatsApp flash sales generated ₹1.8 Lakhs in orders during Ganesh Chaturthi with zero manual messaging.',
      rating: 5,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % (testimonials.length - 2));
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 3 : prev - 1));
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center max-w-3xl mx-auto space-y-2 mb-12">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
            Loved by Businesses Across India
          </h2>
          <p className="text-sm text-slate-500">
            Real stories from business owners scaling faster with TT OS.
          </p>
        </div>

        {/* Testimonials Grid with Navigation Buttons */}
        <div className="relative">
          
          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {testimonials.slice(0, 3).map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-6 border border-slate-200/90 shadow-xs hover:shadow-md transition-all duration-300 flex flex-col justify-between"
              >
                <div className="space-y-4">
                  {/* User Profile Info */}
                  <div className="flex items-center gap-3">
                    <div
                      className={`w-11 h-11 rounded-full bg-gradient-to-tr ${item.avatarBg} text-white font-bold text-xs flex items-center justify-center shadow-sm shrink-0`}
                    >
                      {item.avatar}
                    </div>
                    <div>
                      <h3 className="text-xs font-bold text-slate-900">{item.name}</h3>
                      <p className="text-[11px] text-slate-500">{item.role}</p>
                    </div>
                  </div>

                  {/* Quote */}
                  <p className="text-xs sm:text-[12.5px] text-slate-600 leading-relaxed italic">
                    &ldquo;{item.quote}&rdquo;
                  </p>
                </div>

                {/* Stars Rating */}
                <div className="flex items-center gap-1 pt-4 text-amber-400">
                  {[...Array(item.rating)].map((_, s) => (
                    <Star key={s} className="w-3.5 h-3.5 fill-amber-400" />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Nav Controls */}
          <div className="flex items-center justify-center gap-3 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-9 h-9 rounded-full border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center text-slate-600 hover:text-indigo-600 shadow-xs transition-colors"
              aria-label="Previous testimonial"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button
              onClick={nextTestimonial}
              className="w-9 h-9 rounded-full border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center text-slate-600 hover:text-indigo-600 shadow-xs transition-colors"
              aria-label="Next testimonial"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>

        </div>

      </div>
    </section>
  );
};

export default TTOSTestimonials;
